import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=1028f082&"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js&"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports